module.exports = __webpack_public_path__ + "assets/img/download_github.c69cd973.png";